import React, {Component} from 'react';

export default class CancelledComponent extends Component {
    render() {
        return <div>
            <p>Your subscription is cancelled. You'll get no new chapters without re-subscribing.</p>
        </div>
    }
}
